<div class="consprod-wrap">
  <div class="inner" [ngClass]="{ empty: isEmpty(renderValue) }">
    <span class="icon-type" [inlineSVG]="iconType()"></span>
    <span>{{ renderValue | number: '1.0-2' | nullDash }} kWh</span>
  </div>
